import { AoPath } from './ao-path';
import { PathPointMat } from './path-point/path-point-mat';
import { SettingsService } from '@infodata-group/inf-commons';
import { GmapsPolyline } from '@infodata-group/inf-commons-tools';
import { PathMarkerMat } from './path-marker/path-marker-mat';
import SymbolPath = google.maps.SymbolPath;

export class AoPathMat extends AoPath {
  public override pathPoint: PathPointMat[];
  public override markers: PathMarkerMat[];
  public override displayedMarkers: PathMarkerMat[];

  constructor(id: string, date: Date, pathPoint: PathPointMat[]) {
    super(id, date, pathPoint);
  }

  generatePolyline(settingsService: SettingsService): void {
    const polyline = new GmapsPolyline(
      '',
      '',
      this.pathPoint.map((p) => p.toGmapsPoint())
    );
    polyline.setColor('#000');
    polyline.setIcon(SymbolPath.FORWARD_CLOSED_ARROW);
    this.polyline.push(polyline);
    this.displayedPolyline.push(polyline);
  }

  public override generatePathMarker(pathPoint: PathPointMat): PathMarkerMat {
    return new PathMarkerMat('', pathPoint);
  }
}
